/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { useGoodsWatchlist } from "features/watchlist/useWatchlist";
import { Button } from "ui/chakra/components/Button";

import { OutlineHeartIcon } from "./OutlineHeartIcon/OutlineHeartIcon";
import { SolidHeartIcon } from "./SolidHeartIcon/SolidHeartIcon";

import type { SVGAttributes } from "react";
import type { FcWithoutChildren } from "types/fcWithoutChildren";

const ICON_SIZE: Pick<SVGAttributes<SVGElement>, "height" | "width"> = {
  height: 19,
  width: 20,
};

type Props = {
  itemId: string;
};

export const WatchListButton: FcWithoutChildren<Props> = (props) => {
  const { itemId } = props;

  const { goodsWatchlist, toggleWatchlist } = useGoodsWatchlist([itemId]);

  const isWatched =
    goodsWatchlist?.find((item) => {
      const { eventGoodsFirestoreId, isInWatchlist } = item;
      return isInWatchlist && eventGoodsFirestoreId === itemId;
    }) !== undefined;
  const icon = isWatched ? (
    <SolidHeartIcon {...ICON_SIZE} />
  ) : (
    <OutlineHeartIcon {...ICON_SIZE} />
  );

  // TODO: 多言語対応 https://github.com/balus-co-ltd/spwn/issues/11159
  const buttonLabel = isWatched ? "ウォッチさくじょ" : "ウォッチついか";
  const handleClick = () => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    toggleWatchlist(itemId);
  };

  return (
    <Button
      css={iconStyle}
      leftIcon={icon}
      variant="outline"
      onClick={handleClick}
    >
      {buttonLabel}
    </Button>
  );
};

const iconStyle = css`
  & {
    svg {
      height: 19px;
      width: 20px;
    }
  }
`;
